export const ARMOR = "ATL";
export const FULL_PRIORITY = "Full Loot";
export const GROUP = "Group Loot";
export const ARMOR_KEY = "armor";
export const FULL_PRIORITY_KEY = "full-priority";
export const GROUP_KEY = "group";

export const MYTHIC = "mythic";
export const HEROIC = "heroic";
export const NORMAL = "normal";

export const UNSAVED_BOOSTERS = {
  7: "1-5 (0-1 Item to roll from every boss)",
  8: "7-10 (1-2 Items to roll from every boss)",
  9: "13-15 (2-3 Items to roll from every boss)",
  10: "17-20 (3-4 Items to roll from every boss)",
  11: "22-25 (4-5 Items to roll from every boss)",
};

export const UNSAVED_BOOSTERS_SHORT = {
  7: "1-5",
  8: "7-10",
  9: "13-15",
  10: "17-20",
  11: "22-25",
};
export const BOSSESS = {
  1: "1/8",
  2: "2/8",
  3: "3/8",
  4: "4/8",
  5: "5/8",
  6: "6/8",
  7: "7/8",
  8: "8/8",
};

export const BOSSESS_REV = {
  "1/8": 1,
  "2/8": 2,
  "3/8": 3,
  "4/8": 4,
  "5/8": 5,
  "6/8": 6,
  "7/8": 7,
  "8/8": 8,
};

export const FREE_SLOTS = {
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  10: "10",
  11: "11",
  12: "12",
  13: "13",
  14: "14",
};

export const MYTHIC_LOOT_TYPE = {
  [ARMOR_KEY]: ARMOR,
  [FULL_PRIORITY_KEY]: FULL_PRIORITY,
};
export const LOOT_TYPE = {
  [GROUP_KEY]: GROUP,
  [ARMOR_KEY]: ARMOR,
  [FULL_PRIORITY_KEY]: FULL_PRIORITY,
};
export const RAID_TYPE = {
  [MYTHIC]: "Mythic",
  [HEROIC]: "Heroic",
  [NORMAL]: "Normal",
};
